import { Box, Typography } from "@mui/material";

export const RadioGroupHeader = (props: { label: string }) => {
  const { label } = props;
  return (
    <Box
      sx={{
        paddingTop: 2,
        paddingBottom: 1,
      }}
    >
      <Typography
        variant="small"
        sx={{
          color: "secondary.3",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
